import { HttpContextToken, HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest, HttpResponse } from "@angular/common/http";
import { inject } from "@angular/core";
import { Router } from "@angular/router";
import { catchError, mergeMap, Observable, of, throwError } from "rxjs";
import { formatToken, HEADER_TOKEN, NO_LOGIN_KEY, TOKEN } from "../constants/storageKey";
import { MesRecordsService } from "../services/mes-records.service";
import { TipPopService } from "../services/tip-pop.service";
import { judgeDevicePcOrMobile } from "../utils/useDeviceCategory";

// 未配置时默认值为 true
export const TOKEN_ENABLED = new HttpContextToken<boolean>(() => true)

/**
 * 请求拦截器，除登录接口外，其他接口都需要设置 TOKEN
 * 不要 TOKEN 的接口传递请求元数据 TOKEN_ENABLED，设置为 false 
 * @param req 
 * @param next 
 * @returns 
 */
export default function (req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {

    const router = inject(Router)
    const tp = inject(TipPopService)
    const mesRecordsServe = inject(MesRecordsService)

    const needToken = req.context.get(TOKEN_ENABLED)

    let newReq = req

    if (needToken) {
        const token = localStorage.getItem(TOKEN)

        if (!token) {
            tp.tipPop("登录过期, 请重新登录", 'warning')

            // 如果登陆过期且不选择继续登录则使用当前的默认未登录no_login_key
            let noLoginKey = localStorage.getItem(NO_LOGIN_KEY)
            mesRecordsServe.getDiaListsByNotLogin(noLoginKey)

            router.navigate([`/${judgeDevicePcOrMobile() ? '' : 'pc-'}login`], { replaceUrl: true })
            return throwError(new HttpErrorResponse({ status: 200, statusText: "Invalid token" }))
        }

        newReq = req.clone({
            headers: req.headers.set(HEADER_TOKEN, formatToken(localStorage.getItem(TOKEN)!))
        })
    }

    return next(newReq).pipe(
        mergeMap((event: HttpEvent<unknown>) => {
            return of(event)
        }),
        catchError((err: HttpErrorResponse) => {
            if (err.status === 500) {
                tp.tipPop("服务器错误", 'warning')
            } else if (err.error.code === 401) {
                tp.tipPop("登陆过期, 请重新登陆", 'warning')

                // 如果登陆过期且不选择继续登录则使用当前的默认未登录no_login_key
                let noLoginKey = localStorage.getItem(NO_LOGIN_KEY)
                mesRecordsServe.getDiaListsByNotLogin(noLoginKey)

                if (judgeDevicePcOrMobile()) {
                    router.navigate(['/login'], { replaceUrl: true })
                }
            } else if (err.status === 400) {
                tp.tipPop(err.error.msg, 'warning')
            }

            return handleData(err)
        })
    )
}

// 返回数据处理
function handleData(event: HttpResponse<any> | HttpErrorResponse): Observable<any> {
    if (event instanceof HttpResponse) {
        return of(event)
    } else {
        return throwError(event)
    }
}